<template lang="pug">
  div.loading
    div.loading-bar
    div.loading-progress Loading
      span.progress {{progress}}
      |  %

</template>
<script>
export default {
  name: 'Loading',
  data () {
    return {
      bars: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(d => {
        return {
          height: parseInt(Math.random() * 80),
          speed: 1 + Math.random(),
          color: `rgba(120,172,206, ${Math.random() * 0.5 + 0.5})`
        }
      }),
      handler: '',
      progress: 0
    }
  },
  created () {

  },
  mounted () {
    let bars = this.bars
    let canvas = document.createElement('canvas')
    canvas.setAttribute('width', 150)
    canvas.setAttribute('height', 80)
    let ctx = canvas.getContext('2d')
    this.$el.querySelector('.loading-bar').appendChild(canvas)
    let gap = 5
    let barWidth = (150 - (gap * bars.length - 1)) / this.bars.length
    let draw = function draw () {
      ctx.clearRect(0, 0, 150, 80)
      bars.forEach((d, i) => {
        ctx.fillStyle = d.color
        let x = (gap + barWidth) * i
        let y = 80 - d.height
        if (d.height >= 80) {
          d.speed = -d.speed
        } else if (d.height <= 0) {
          d.speed = -d.speed
        }
        d.height += d.speed
        let progress = this.progress + 0.01
        if (progress >= 99.99) {
          progress = 99.99
        }
        this.progress = +(progress).toFixed(2)
        ctx.fillRect(x, y, barWidth, d.height)
      })
      ctx.fill()
    }.bind(this)
    // eslint-disable-next-line
    let handler = this.handler
    function animate () {
      draw()
      handler = window.requestAnimationFrame(animate)
    }
    handler = window.requestAnimationFrame(animate)
  },
  destroyed () {
    window.cancelAnimationFrame(this.handler)
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column nowrap;
  width: 100%;
  height: 100%;
  color:#666;
  font-size: 12px;
    .loading-bar {
      display: flex;
      align-items:flex-end;
      justify-content: center;
      height: 100px;
      margin-bottom: 20px;
      .bar {
        width: 10px;
        height: 100%;
        margin: 0 2px;
        background: #f55;
      }
    }

    .progress {
      display: inline-block;
      text-align: right;
      min-width: 40px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/Loading.vue